import {
  VendorTaxonomyKey,
  VENUES_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { MatchDimension } from '@zola/svc-marketplace-ts-types';

import { StorefrontBooking } from '~/types/types';
import { formatDateUtc } from '~/util/dateUtils';

const assessedResults: MatchDimension.MatchResultEnum[] = [
  'FULL_MATCH',
  'PARTIAL_MATCH',
  'NO_MATCH',
];

export const matchAssessed = (matchResult?: MatchDimension.MatchResultEnum | null): boolean => {
  return matchResult ? assessedResults.includes(matchResult) : false;
};

export const allowsExpandedWeddingDates = (taxonomyKey: VendorTaxonomyKey) => {
  return taxonomyKey === VENUES_TAXONOMY_KEY;
};

export const isBooked = (bookedDates: StorefrontBooking[], weddingDate: Date | null) => {
  if (!weddingDate) {
    return false;
  }

  return Boolean(
    // This is just a hot mess
    // As of 7/14/2021, the booked dates are "noon in the vendors timezone" as a
    // milliseconds since epoch number.  The "raw wedding date" is a string
    // like "2021-09-09T00:00:00.000Z".  Fortunately, datejs is magical and
    // can do all this for us, but the UTC / local time problem here makes falling
    // back to formatting the dates as strings and comparing the best bet.
    bookedDates.find(
      (date: StorefrontBooking) =>
        formatDateUtc(weddingDate, 'YYYY-M-D') === formatDateUtc(date.bookedDate, 'YYYY-M-D')
    )
  );
};
